import { render, staticRenderFns } from "./mod12.vue?vue&type=template&id=6942d1c8&scoped=true&"
import script from "./mod12.vue?vue&type=script&lang=js&"
export * from "./mod12.vue?vue&type=script&lang=js&"
import style0 from "./mod12.vue?vue&type=style&index=0&id=6942d1c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6942d1c8",
  null
  
)

export default component.exports